import { animate, state, style, transition, trigger } from '@angular/animations';

export const carouselItemAnimations = trigger('openClose', [
  state(
    'open',
    style({
      transform: 'scale(1.1)',
      opacity: 0,
    })
  ),
  state(
    'closed',
    style({
      transform: 'scale(1)',
      opacity: 1,
    })
  ),
  state('*', style({ transform: 'scale(1)', opacity: 1 })),
  transition('* => closed', [animate('200ms ease-in-out')]),
  transition('* => open', [animate('300ms 600ms ease-in-out')]),
  /*
  "*" state and transitions are used instead of open=>closed, closed=>open transitions
  to prevent a bug when hovering an element could cause a missing animation trigger on the first hover.
  */
]);
